import type Owner from '@ember/owner';
import { setOwner } from '@ember/owner';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { ParityConfig } from 'lumen/models';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';
import getAPIErrorMessage from 'lumen/utils/get-api-error-message';
import SilentTaskError from 'lumen/utils/silent-task-error';

export default class ConfigResource {
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];
  @service declare store: Services['store'];

  #isSingleProperty: boolean;

  fetchResourceTask = task({ restartable: true }, async () => {
    const path = this.#isSingleProperty
      ? `parityanalytics/subscriptions/${this.hotelAndMarketService.hotelOrMarket.id}`
      : `parityanalytics/markets/${this.hotelAndMarketService.hotelOrMarket.id}`;
    try {
      const requestParams = {
        namespace: APIGATEWAY,
        typeKey: `${path}/config`,
      };

      return await this.store.queryRecord<ParityConfig>(
        'parity/config',
        requestParams,
      );
    } catch (error) {
      this.errorTracking.captureException(error);
      throw new SilentTaskError(getAPIErrorMessage(error, this.intl));
    }
  });

  constructor(owner: Owner, params: { isSingleProperty: boolean }) {
    setOwner(this, owner);
    this.#isSingleProperty = params.isSingleProperty;
  }
}
